import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=9bb65ca4&"
import script from "./TagsView.vue?vue&type=script&lang=ts&"
export * from "./TagsView.vue?vue&type=script&lang=ts&"
import style0 from "./TagsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports